import type { Option, ValidationFunctionResult, Webhook } from "~/shared/types";

export const DUID_REGEX = /^[a-zA-Z0-9]{12}$/;
export const CONTAINS_EMAIL_REGEX =
  /(([^<>()[\]\\.,;:@"]+(\.[^<>()[\]\\.,;:@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
export const EMAIL_REGEX = new RegExp(`^${CONTAINS_EMAIL_REGEX.source}$`);
const URL_PREFIX = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#={}|^`<>"\\[\]]{1,256}\./;
const TLD_REGEX =
  /(a(a(a|rp)|b(b(|ott|vie)|c|le|ogado|udhabi)|c(|ademy|c(enture|ountant(|s))|o|tor)|d(|s|ult)|e(|g|ro|tna)|f(|l|rica)|g(|akhan|ency)|i(|g|r(bus|force|tel))|kdn|l(|i(baba|pay)|l(finanz|state|y)|s(ace|tom))|m(|azon|e(rican(express|family)|x)|fam|ica|sterdam)|n(alytics|droid|quan|z)|o(|l)|p(artments|p(|le))|q(|uarelle)|r(|a(b|mco)|chi|my|pa|t(|e))|s(|da|ia|sociates)|t(|hleta|torney)|u(|ction|di(|ble|o)|spost|t(hor|o(|s)))|w(|s)|x(|a)|z(|ure))|b(a(|by|idu|n(amex|d|k)|r(|c(elona|lay(card|s))|efoot|gains)|s(eball|ketball)|uhaus|yern)|b(|c|t|va)|c(g|n)|d|e(|a(ts|uty)|er|rlin|st(|buy)|t)|f|g|h(|arti)|i(|ble|d|ke|ng(|o)|o|z)|j|l(ack(|friday)|o(ckbuster|g|omberg)|ue)|m(|s|w)|n(|pparibas)|o(|ats|ehringer|fa|m|nd|o(|k(|ing))|s(ch|t(ik|on))|t|utique|x)|r(|adesco|idgestone|o(adway|ker|ther)|ussels)|s|t|u(ild(|ers)|siness|y|zz)|v|w|y|z(|h))|c(a(|b|fe|l(|l|vinklein)|m(|era|p)|non|p(etown|ital(|one))|r(|avan|ds|e(|er(|s))|s)|s(a|e|h|ino)|t(|ering|holic))|b(a|n|re)|c|d|e(nter|o|rn)|f(|a|d)|g|h(|a(n(el|nel)|rity|se|t)|eap|intai|r(istmas|ome)|urch)|i(|priani|rcle|sco|t(adel|i(|c)|y))|k|l(|aims|eaning|i(ck|ni(c|que))|o(thing|ud)|ub(|med))|m|n|o(|ach|des|ffee|l(lege|ogne)|m(|m(bank|unity)|p(a(ny|re)|uter)|sec)|n(dos|s(truction|ulting)|t(act|ractors))|o(king|l|p)|rsica|u(ntry|pon(|s)|rses))|pa|r(|edit(|card|union)|icket|own|s|uise(|s))|u(|isinella)|v|w|x|y(|mru|ou)|z)|d(a(d|nce|t(a|e|ing|sun)|y)|clk|ds|e(|al(|er|s)|gree|l(ivery|l|oitte|ta)|mocrat|nt(al|ist)|si(|gn)|v)|hl|i(amonds|et|gital|rect(|ory)|s(co(unt|ver)|h)|y)|j|k|m|np|o(|c(s|tor)|g|mains|t|wnload)|rive|tv|u(bai|nlop|pont|rban)|v(ag|r)|z)|e(a(rth|t)|c(|o)|d(eka|u(|cation))|e|g|m(ail|erck)|n(ergy|gineer(|ing)|terprises)|pson|quipment|r(|icsson|ni)|s(|q|tate)|t|u(|rovision|s)|vents|x(change|p(ert|osed|ress)|traspace))|f(a(ge|i(l|rwinds|th)|mily|n(|s)|rm(|ers)|s(hion|t))|e(dex|edback|rr(ari|ero))|i(|d(elity|o)|lm|na(l|nc(e|ial))|r(e(|stone)|mdale)|sh(|ing)|t(|ness))|j|k|l(i(ckr|ghts|r)|o(rist|wers)|y)|m|o(|o(|d|tball)|r(d|ex|sale|um)|undation|x)|r(|e(e|senius)|l|o(gans|ntier))|tr|u(jitsu|n(|d)|rniture|tbol)|yi)|g(a(|l(|l(ery|o|up))|me(|s)|p|rden|y)|b(|iz)|d(|n)|e(|a|nt(|ing)|orge)|f|g(|ee)|h|i(|ft(|s)|v(es|ing))|l(|ass|e|ob(al|o))|m(|ail|bh|o|x)|n|o(daddy|l(d(|point)|f)|o(|dyear|g(|le))|p|t|v)|p|q|r(|a(inger|phics|tis)|een|ipe|o(cery|up))|s|t|u(|cci|ge|i(de|tars)|ru)|w|y)|h(a(ir|mburg|ngout|us)|bo|dfc(|bank)|e(alth(|care)|l(p|sinki)|r(e|mes))|i(phop|samitsu|tachi|v)|k(|t)|m|n|o(ckey|l(dings|iday)|me(depot|goods|s(|ense))|nda|rse|s(pital|t(|ing))|t(|els|mail)|use|w)|r|sbc|t|u(|ghes)|y(att|undai))|i(bm|c(bc|e|u)|d|e(|ee)|fm|kano|l|m(|amat|db|mo(|bilien))|n(|c|dustries|f(initi|o)|g|k|s(titute|ur(ance|e))|t(|ernational|uit)|vestments)|o|piranga|q|r(|ish)|s(|maili|t(|anbul))|t(|au|v))|j(a(guar|va)|cb|e(|ep|tzt|welry)|io|ll|m(|p)|nj|o(|b(s|urg)|t|y)|p(|morgan|rs)|u(egos|niper))|k(aufen|ddi|e(|rry(hotels|properties))|fh|g|h|i(|a|ds|m|ndle|tchen|wi)|m|n|o(eln|matsu|sher)|p(|mg|n)|r(|d|ed)|uokgroup|w|y(|oto)|z)|l(a(|caixa|m(borghini|er)|n(d(|rover)|xess)|salle|t(|ino|robe)|w(|yer))|b|c|ds|e(ase|clerc|frak|g(al|o)|xus)|gbt|i(|dl|fe(|insurance|style)|ghting|ke|lly|m(ited|o)|n(coln|k)|v(e|ing))|k|l(c|p)|o(an(|s)|c(ker|us)|l|ndon|tt(e|o)|ve)|pl(|financial)|r|s|t(|d(|a))|u(|ndbeck|x(e|ury))|v|y)|m(a(|drid|i(f|son)|keup|n(|agement|go)|p|r(ket(|ing|s)|riott|shalls)|ttel)|ba|c(|kinsey)|d|e(|d(|ia)|et|lbourne|m(e|orial)|n(|u)|rckmsd)|g|h|i(ami|crosoft|l|n(i|t)|t(|subishi))|k|l(|b|s)|m(|a)|n|o(|bi(|le)|da|e|i|m|n(ash|ey|ster)|r(mon|tgage)|scow|to(|rcycles)|v(|ie))|p|q|r|s(|d)|t(|n|r)|u(|s(eum|ic))|v|w|x|y|z)|n(a(|b|goya|me|vy)|ba|c|e(|c|t(|bank|flix|work)|ustar|w(|s)|x(t(|direct)|us))|f(|l)|g(|o)|hk|i(|co|k(e|on)|nja|ssa(n|y))|l|o(|kia|rton|w(|ruz|tv))|p|r(|a|w)|tt|u|yc|z)|o(b(i|server)|ffice|kinawa|l(ayan(|group)|lo)|m(|ega)|n(e|g|l(|ine))|oo|pen|r(a(cle|nge)|g(|anic)|igins)|saka|t(suka|t)|vh)|p(a(|ge|nasonic|r(is|s|t(ners|s|y))|y)|ccw|e(|t)|f(|izer)|g|h(|armacy|d|ilips|o(ne|to(|graphy|s))|ysio)|i(c(s|t(et|ures))|d|n(|g|k)|oneer|zza)|k|l(|a(ce|y(|station))|u(mbing|s))|m|n(|c)|o(hl|ker|litie|rn|st)|r(|a(merica|xi)|ess|ime|o(|d(|uctions)|f|gressive|mo|pert(ies|y)|tection)|u(|dential))|s|t|ub|w(|c)|y)|q(a|pon|ue(bec|st))|r(a(cing|dio)|e(|a(d|l(estate|t(or|y)))|cipes|d(|stone|umbrella)|hab|i(se(|n)|t)|liance|n(|t(|als))|p(air|ort|ublican)|st(|aurant)|view(|s)|xroth)|i(c(h(|ardli)|oh)|l|o|p)|o(|cks|deo|gers|om)|s(|vp)|u(|gby|hr|n)|w(|e)|yukyu)|s(a(|arland|fe(|ty)|kura|l(e|on)|ms(club|ung)|n(dvik(|coromant)|ofi)|p|rl|s|ve|xo)|b(|i|s)|c(|b|h(aeffler|midt|o(larships|ol)|ule|warz)|ience|ot)|d|e(|a(rch|t)|cur(e|ity)|ek|lect|ner|rvices|ven|w|x(|y))|fr|g|h(|a(ngrila|rp)|ell|i(a|ksha)|o(es|p(|ping)|uji|w))|i(|lk|n(a|gles)|te)|j|k(|i(|n)|y(|pe))|l(|ing)|m(|art|ile)|n(|cf)|o(|c(cer|ial)|ft(bank|ware)|hu|l(ar|utions)|n(g|y)|y)|p(a(|ce)|o(rt|t))|r(|l)|s|t(|a(da|ples|r|te(bank|farm))|c(|group)|o(ckholm|r(age|e))|ream|ud(io|y)|yle)|u(|cks|pp(l(ies|y)|ort)|r(f|gery)|zuki)|v|w(atch|iss)|x|y(|dney|stems)|z)|t(a(b|ipei|lk|obao|rget|t(a(motors|r)|too)|x(|i))|c(|i)|d(|k)|e(am|ch(|nology)|l|masek|nnis|va)|f|g|h(|d|eat(er|re))|i(aa|ckets|enda|ps|r(es|ol))|j(|maxx|x)|k(|maxx)|l|m(|all)|n|o(|day|kyo|ols|p|ray|shiba|tal|urs|wn|y(ota|s))|r(|a(d(e|ing)|ining|vel(|ers(|insurance)))|ust|v)|t|u(be|i|nes|shu)|v(|s)|w|z)|u(a|b(ank|s)|g|k|n(i(com|versity)|o)|ol|ps|s|y|z)|v(a(|cations|n(a|guard))|c|e(|gas|ntures|r(isign|sicherung)|t)|g|i(|ajes|deo|g|king|llas|n|p|rgin|s(a|ion)|v(a|o))|laanderen|n|o(dka|lvo|t(e|ing|o)|yage)|u)|w(a(l(es|mart|ter)|ng(|gou)|tch(|es))|e(ather(|channel)|b(cam|er|site)|d(|ding)|i(bo|r))|f|hoswho|i(en|ki|lliamhill|n(|dows|e|ners))|me|o(lterskluwer|odside|r(k(|s)|ld)|w)|s|t(c|f))|x(box|erox|i(huan|n)|n--(1(1b4c3d|ck2e1b|qqw23a)|2scrj9c|3(0rr7y|bst00m|ds443g|e0b707e|hcrj9c|pxu8k)|4(2c2d9a|5(br(5cyl|j9c)|q11c)|dbrk0ce|gbrim)|5(4b7fta0cc|5q(w42g|x5d)|su34j936bgsg|tzm5g)|6(frz82g|qq986b3xl)|8(0a(dxhks|o21a|qecdr1a|s(ehdb|wg))|y0a063a)|9(0a(3ac|e|is)|dbq2a|et52u|krt00a)|b(4w605ferd|ck1b9a5dre4c)|c(1avg|2br7g|ck(2b3b|wcxetd)|g4bki|lchc0ea0b2g2a9gcd|zr(694b|s0t|u2d))|d1a(cj3b|lf)|e(1a4c|ckvdtc9d|fvy88h)|f(ct429k|hbei|iq(228c5hs|64b|s8s|z9s)|jq720a|lw351e|pcrj9c3d|z(c2c9e2c|ys8d69uvgm))|g(2xx48c|ckr3f0f|ecrj9c|k3at1e)|h(2br(eg3eve|j9c(|8c))|xt814e)|i(1b6b1a6a2e|mr513n|o0a7i)|j(1a(ef|mh)|6w193g|lq480n2rg|vr189m)|k(crx77d1x4a|p(r(w13d|y57d)|ut3i))|l(1acc|gbbat1ad8j)|m(gb(9awbf|a(3a(3ejt|4f16a)|7c0bbn0a|am7a8h|b2bd|h1a3hjkrd|i9azgqp6j|yh7gpa)|bh1a(|71e)|c(0a9azcg|a7dzdo|pq6gpa1a)|erp4a5d4ar|gu82a|i4ecexp|pl2fh|t(3dhd|x2b)|x4cd0ab)|ix891f|k1bu44c|xtq1m)|n(gb(c5azd|e9e0a|rx)|ode|qv7f(|s00ema)|yqy26a)|o(3cw4h|gbpf8fl|tu796d)|p(1a(cf|i)|gbs0dh|ssy2u)|q(7ce6a|9jyb4c|cka1pmc|xa(6a|m))|r(hqv96g|ovu88b|vc1e0am3e)|s(9brj9c|es554g)|t(60b56a|ckwe|iq49xqyj)|unup4y|v(ermgensberat(er-ctb|ung-pwb)|hquv|uq861b)|w(4r(85el8fhu5dnra|s40l)|gb(h1c|l6a))|x(hq521b|kc2(al3hye2a|dl3a5ee0h))|y(9a3aq|fro4i67o|gbi2ammx)|zfr164b)|xx|yz)|y(a(chts|hoo|maxun|ndex)|e|o(dobashi|ga|kohama|u(|tube))|t|un)|z(a(|ppos|ra)|ero|ip|m|one|uerich|w))/; // spell-checker: disable-line
const URL_SUFFIX = /(?<suffix>[-a-zA-Z0-9@:%_+.~#?&/=!$'()*,;]*)/;
export const CONTAINS_URL_REGEX = new RegExp(`${URL_PREFIX.source}${TLD_REGEX.source}${URL_SUFFIX.source}`);
export const URL_REGEX = new RegExp(`^${CONTAINS_URL_REGEX.source}$`);
export const CONTAINS_LOCAL_URL_REGEX =
  /https?:\/\/(?:localhost|0|10|127|192(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}|\[::1?\])(?::\d{4,6})?(?<suffixLocal>[-a-zA-Z0-9@:%_+.~#?&/=!$'()*,;]*)/;
export const LOCAL_URL_REGEX = new RegExp(`^${CONTAINS_LOCAL_URL_REGEX.source}$`);
export const CONTAINS_URL_INCLUDING_LOCAL_REGEX = new RegExp(
  `${CONTAINS_URL_REGEX.source}|${CONTAINS_LOCAL_URL_REGEX.source}`
);
export const URL_INCLUDING_LOCAL_REGEX = new RegExp(`^${CONTAINS_URL_INCLUDING_LOCAL_REGEX.source}$`);
export const COLOR_HEX_REGEX = /^#[a-fA-F0-9]{6}$/;

export const HEADER_KEY_REGEX = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;

export const CONTAINS_DART_URL_REGEX =
  /https:\/\/(?:app|stag)\.dartai\.com(?<suffix>[-a-zA-Z0-9@:%_+.~#?&/=!$'()*,;]*)/;
export const DART_URL_REGEX = new RegExp(`^${CONTAINS_DART_URL_REGEX.source}$`);
export const DART_URL_INCLUDING_LOCAL_REGEX = new RegExp(
  `^${CONTAINS_DART_URL_REGEX.source}|${CONTAINS_LOCAL_URL_REGEX.source}$`
);

export const validateIsNotEmpty = (value: string): ValidationFunctionResult => {
  if (value.trim().length === 0) {
    return { isValid: false, error: "Enter a value" };
  }

  return { isValid: true };
};

export const isValidDuid = (duid: string) => DUID_REGEX.test(duid);

export const isValidEmail = (email: string) => email.length <= 254 && EMAIL_REGEX.test(email);

export const validateEmail = (email: string): ValidationFunctionResult => {
  if (email.length === 0) {
    return { isValid: false, error: "Enter an email" };
  }

  if (!isValidEmail(email)) {
    return { isValid: false, error: "Enter a valid email" };
  }

  return { isValid: true };
};

export const validatePassword = (password: string): ValidationFunctionResult => {
  if (password.length === 0) {
    return { isValid: false, error: "Enter a password" };
  }

  if (password.length < 12) {
    return { isValid: false, error: "Enter a longer password" };
  }

  if (password.length > 100) {
    return { isValid: false, error: "Enter a shorter password" };
  }

  if (!/[^a-zA-Z]/.test(password)) {
    return { isValid: false, error: "Enter a password with at least one number or symbol" };
  }

  return { isValid: true };
};

export const validatePasswordBasic = (password: string): ValidationFunctionResult => {
  if (password.length === 0) {
    return { isValid: false, error: "Enter your password" };
  }
  return { isValid: true };
};

export const validateName = (name: string): ValidationFunctionResult => {
  if (name.length === 0) {
    return { isValid: false, error: "Enter your name" };
  }

  return { isValid: true };
};

export const makeValidateTenantName =
  (isDart: boolean) =>
  (name: string): ValidationFunctionResult => {
    if (name.length === 0) {
      return { isValid: false, error: "Enter a team name" };
    }

    if (isDart && name !== "Dart") {
      return { isValid: false, error: "The Dart tenant must be named Dart" };
    }

    return { isValid: true };
  };

export const makeValidateOptionTitle =
  (getOptionByTitle: (title: string) => Option | undefined) =>
  (optionTitle: string): ValidationFunctionResult => {
    const trimmedTitle = optionTitle.trim();
    if (trimmedTitle.length === 0) {
      return { isValid: false, error: "Enter an option name" };
    }

    if (getOptionByTitle(trimmedTitle) !== undefined) {
      return { isValid: false, error: "Enter a unique option name" };
    }

    return { isValid: true };
  };

export const isValidDartUrl = (url: string, isLocal: boolean) =>
  (isLocal ? DART_URL_INCLUDING_LOCAL_REGEX : DART_URL_REGEX).test(url);

export const isValidUrl = (url: string) => URL_REGEX.test(url);

export const validateUrl = (url: string): ValidationFunctionResult => {
  if (url.length === 0) {
    return { isValid: false, error: "Enter a URL" };
  }

  if (!isValidUrl(url)) {
    return { isValid: false, error: "Enter a valid URL" };
  }

  return { isValid: true };
};

export const isValidUrlIncludingLocal = (url: string) => URL_INCLUDING_LOCAL_REGEX.test(url);

export const isValidLocalUrl = (url: string) => LOCAL_URL_REGEX.test(url);

export const makeValidateWebhookUrl =
  (urlBase: string, existingWebhooks?: Webhook[], currentWebhookDuid?: string) =>
  (url: string): ValidationFunctionResult => {
    if (url === "") {
      return { isValid: false, error: "Enter a URL" };
    }
    if (isValidLocalUrl(url)) {
      return { isValid: false, error: "Enter a URL that is not local" };
    }
    if (url.startsWith(urlBase)) {
      return { isValid: false, error: "Enter a URL that is not from Dart" };
    }
    if (existingWebhooks?.some((webhook) => webhook.url === url && webhook.duid !== currentWebhookDuid)) {
      return { isValid: false, error: "Enter a URL that is not already in use by another endpoint" };
    }
    return validateUrl(url);
  };

export const isValidXml = (xml: string) => {
  const parser = new DOMParser();
  let res;
  try {
    res = parser.parseFromString(xml, "application/xml");
  } catch {
    return false;
  }
  return res.getElementsByTagName("parsererror").length === 0;
};

export const validateXml = (xml: string): ValidationFunctionResult => {
  if (xml.length === 0) {
    return { isValid: false, error: "Enter some XML" };
  }

  if (!isValidXml(xml)) {
    return { isValid: false, error: "Enter valid XML" };
  }

  return { isValid: true };
};

export const validateColorHex = (hex: string): ValidationFunctionResult => {
  if (!COLOR_HEX_REGEX.test(hex)) {
    return { isValid: false, error: "Enter a valid color hex" };
  }
  return { isValid: true };
};

export const makeValidateHeaderKey =
  (existingHeaders?: [string, string][], currentIndex?: number) =>
  (key: string): ValidationFunctionResult => {
    if (!key.trim()) {
      return { isValid: false, error: "Enter a header key" };
    }
    if (!HEADER_KEY_REGEX.test(key)) {
      return { isValid: false, error: "Enter a valid header key" };
    }

    if (existingHeaders) {
      const hasDuplicate = existingHeaders.some(
        ([headerKey], index) => index !== currentIndex && headerKey.trim().toLowerCase() === key.trim().toLowerCase()
      );

      if (hasDuplicate) {
        return { isValid: false, error: "Enter a header that is not already in use" };
      }
    }

    return { isValid: true };
  };
